<ng-container *ngIf="!forcePolaris; else notOneComponent">
  <div [attr.data-e2e]="e2e" [attr.data-info-level]="infoLevel">
    <div class="feedback row">
      <!-- feedback icon -->
      <div class="col-12 col-md-4 col-xl-3">
        <div class="alert mx-n1 mx-md-0" [ngClass]="iconClass.background">
          <span class="alert-icon" [ngClass]="iconClass.icon" aria-hidden="true"></span>
        </div>
      </div>
      <!-- feedback body -->
      <div class="col-12 col-md-8 col-xl-9">
        <!-- default or custom title -->
        <ng-container *ngIf="title; else customTitle">
          <h2 class="h3 feedback-title h3" [attr.data-e2e]="e2e + '-title'">{{title}}</h2>
        </ng-container>
        <!-- default or custom text -->
        <ng-container *ngIf="displayedText && displayedText.length > 0; else contentTpl">
          <div [attr.data-e2e]="e2e + '-body'">
            <p *ngFor="let val of displayedText; let index = index" class="feedback-text">{{val}}</p>
          </div>
        </ng-container>
        <!-- confirmation button -->
        <div *ngIf="confirmationLabel" class="feedback-button">
          <a
            href=""
            class="btn btn-secondary"
            (click)="feedbackConfirm(); false"
            [attr.data-e2e]="e2e + '-confirmation'"
          >
            {{confirmationLabel}}</a
          >
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #notOneComponent>
  <div
    class="ecm-frame ecm-panel bg-white d-flex flex-column flex-md-row"
    [attr.data-e2e]="e2e"
    [attr.data-info-level]="infoLevel"
  >
    <!-- icon -->
    <span
      class="mr-md-3 material-feedback-icon"
      [ngClass]="iconClass.icon + ' ' + iconClass.iconColor"
      aria-hidden="true"
    ></span>

    <!-- content -->
    <div class="pt-2 material-feedback-content-overflow">
      <!-- title -->
      <ng-container *ngIf="title">
        <!-- mobile render -->
        <h1 class="d-block d-md-none h2 text-center" [attr.data-e2e]="e2e + '-title'">{{title}}</h1>

        <!-- desktop render, child of <h1> page -->
        <h2 class="d-none d-md-block h3" [attr.data-e2e]="e2e + '-title'">{{title}}</h2>
      </ng-container>

      <!-- custom html title -->
      <div *ngIf="!title" [attr.data-e2e]="e2e + '-title'">
        <ng-container *ngTemplateOutlet="customTitle"></ng-container>
      </div>

      <!-- body -->
      <div class="mt-3" [attr.data-e2e]="e2e + '-body'" [ngClass]="{'mb-3': confirmationStyle}">
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
      </div>

      <ng-container *ngIf="confirmationStyle">
        <!-- link / button -->
        <div [ngSwitch]="confirmationStyle">
          <!-- link -->
          <ng-container *ngSwitchCase="'link'">
            <!-- mobile separator -->
            <hr class="d-block d-md-none" />

            <a class="o-link-arrow" href="" (click)="feedbackConfirm(); false" [attr.data-e2e]="e2e + '-confirmation'">
              {{confirmationLabel}}
            </a>
          </ng-container>

          <!-- button primary -->
          <button
            *ngSwitchCase="'button-primary'"
            class="btn btn-primary"
            (click)="feedbackConfirm(); false"
            [attr.data-e2e]="e2e + '-confirmation'"
          >
            {{confirmationLabel}}
          </button>

          <!-- button secondary -->
          <button
            *ngSwitchCase="'button-secondary'"
            class="btn btn-secondary"
            (click)="feedbackConfirm(); false"
            [attr.data-e2e]="e2e + '-confirmation'"
          >
            {{confirmationLabel}}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #customTitle>
  <div [attr.data-e2e]="e2e + '-title'">
    <ng-content select="[title]"></ng-content>
  </div>
</ng-template>

<ng-template #contentTpl>
  <div [attr.data-e2e]="e2e + '-body'">
    <p class="feedback-text">
      <ng-content></ng-content>
    </p>
  </div>
</ng-template>
